import { Trash2 } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

interface FilterDeleteButtonProps {
  onDelete: () => void;
  disabled: boolean;
  filterIndex: number; // For data-testid
}

/**
 * FilterDeleteButton - Trash icon button for deleting individual filters
 *
 * Renders a grey trash icon that becomes red on hover (when enabled).
 * Disabled state shown with reduced opacity and cursor-not-allowed.
 * Click event stops propagation to prevent parent interactions.
 */
export const FilterDeleteButton = ({
  onDelete,
  disabled,
  filterIndex,
}: FilterDeleteButtonProps) => {
  return (
    <button
      onClick={e => {
        e.stopPropagation(); // Prevent any parent interactions
        onDelete();
      }}
      disabled={disabled}
      className={twMerge(
        'rounded p-1 transition-colors duration-200',
        disabled
          ? 'cursor-not-allowed opacity-40'
          : 'text-gray-400 hover:bg-red-50 hover:text-red-500'
      )}
      aria-label={disabled ? 'Cannot delete filter' : 'Delete filter'}
      title={
        disabled
          ? 'Cannot delete filter in read-only mode'
          : 'Delete this filter'
      }
      data-testid={`filter-delete-button-${filterIndex}`}
    >
      <Trash2 size={16} />
    </button>
  );
};
